<template>
  <div
    class="bb-upload-file"
    :class="{'bb-upload-file_edit': editable}"
  >
    <label>{{ label }}</label>
    <div>
    <transition-group name="list" tag="div">
      <div
        class="bb-upload-file-list"
        v-for="(item, index) in currentFiles"
        :key="`${item.id}${item.name}${item._id}`"
      >
        <div
          @click="openFile(item)"
          class="bb-upload-file-list-section"
          :class="{'bb-upload-file-list-section_edit-mode': !editable}"
        >
          <i class="icon-file"/>
          <span class="bb-upload-file-list-section__text">
            {{ item.name || item.label }}
          </span>
        </div>
        <div
          v-if="editable"
          class="bb-upload-file-list__button"
          @click="deleteFile(index, item)"
        >
          <i class="icon-cross"/>
        </div>
      </div>
    </transition-group>
    <template v-if="editable">
      <label
        class="bb-upload-file__file"
        :class="{'bb-upload-file__file_highlight': drop}"
        ref="bbFiles"
        for="upload-photo"
        @dragenter="drop = true"
        @dragover="drop = true"
        @dragleave="drop = false"
        @drop="onDrop"
      >
        <i class="icon-vector"/>
        Add file
      </label>
      <input
        style="display: none"
        type="file"
        multiple
        id="upload-photo"
        @change="setFile"
      >
    </template>
    </div>
  </div>
</template>

<script>

import UploadFileApi from '@/api/UploadFile/api'
import {get, map} from 'lodash'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'BBUploadFile',
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    editable: {
      type: Boolean,
      default: false
    },
    loaderRun: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    drop: false
  }),
  computed: {
    currentFiles: {
      get () {
        return this.items
      },
      set (data) {
        this.$emit('update:items', data)
      }
    }
  },
  methods: {
    openFile (file) {
      const { id, type, name, blob, label } = file
      if (!id) {
        const objectURL = window.URL.createObjectURL(file)
        type.includes('image') ? window.open(objectURL, name) : saveAs(file, name)
        return
      }
      if (blob) {
        saveAs(blob, label)
      } else {
        this.getFile(file)
      }
    },
    getFile (file) {
      this.$emit('update:loaderRun', true)
      UploadFileApi.getFile(file.id, true)
        .then(({data}) => {
          const blob = b64toBlob(data.base64, data.type)
          file.blob = blob
          saveAs(blob, data.label)
          this.$emit('update:loaderRun', false)
        })
        .catch(err => {
          this.$emit('update:loaderRun', false)
          console.error(err)
        })
    },
    deleteFile (index, item) {
      const { id } = item
      if (!id) {
        this.currentFiles.splice(index, 1)
        return
      }
      UploadFileApi.deleteFile(id, true)
        .then(res => {
          this.currentFiles.splice(index, 1)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    setFile ({ target }) {
      if (!target.files.length) return
      const files = map(target.files, file => file)
      files.map(el => (el._id = Date.now()))
      this.currentFiles = [...this.items, ...files]
      target.value = ''
    },
    onDrop (e) {
      this.drop = false
      const newFile = get(e, 'dataTransfer.files', '')
      const files = map(newFile, file => file)
      files.map(el => (el._id = Date.now()))
      this.currentFiles = [...this.currentFiles, ...files]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.bb-upload-file {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  color: $color-accent;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;

  &_edit {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $color-wild-sand;
    color: $color-accent;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;

    &:last-child {
      border-bottom: none;
    }
  }

  &__file {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 216px;
    height: 30px;
    border: 1px dashed $color-denim;
    box-sizing: border-box;
    border-radius: 5px;
    color: $color-denim;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: $color-accent-hover;
      border-color: $color-accent-hover;
    }

    &_highlight {
      color: $color-accent-hover;
      border-color: $color-accent-hover;
    }
  }
}

.bb-upload-file-list {
  display: flex;

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid $color-mercury;
    box-sizing: border-box;
    border-radius: 5px;
    cursor: pointer;
    color: $color-denim;

    &:hover {
      border-color: $color-borders;
      transition: 0.3s;
    }
  }
}

.bb-upload-file-list-section {
  display: flex;
  align-items: center;
  padding-left: 13px;
  width: 178px;
  height: 30px;
  border: 1px solid $color-mercury;
  box-sizing: border-box;
  border-radius: 5px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
  margin-right: 8px;
  cursor: pointer;
  color: $color-denim;

  &__text {
    padding: 0 8px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: $color-black;

    &:hover {
      color: $color-accent-hover;
      transition: 0.3s;
    }
  }

  &__icon:hover {
    color: $color-accent-hover;
    transition: 0.3s;
  }

  &:hover {
    border-color: $color-borders;
    transition: 0.3s;
  }

  &_edit-mode {
    display: flex;
    flex-direction: row-reverse;
    padding: 0;
    margin: 0;
    border: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBUploadFile/BBUploadFile.vue